import React from 'react'
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import "react-datepicker/dist/react-datepicker.css";

const NewDateGeneric = ({ handleChange, values, errors, placeholderVal, field, moduleText, occupation }) => {
    const { t } = useTranslation();
    return (
        <div className={`col-md-${occupation}`}>
            <label htmlFor="name" className="form-label tit-view">
                {t(`${moduleText}.short.${field}`)}
            </label>
            <DatePicker
                showYearPicker={false}
                dateFormat="MM-dd-yyyy"
                
                className={`form-control txt-view ${errors[field] && "border border-danger"}`}
                selected={values[field] ? new Date(values[field]) : ""}
                onChange={(event) => handleChange(event, field)}
                name={field}
                id={field}
                required
                autoComplete="off"
                placeholderText={placeholderVal ? t(`${moduleText}.short.${field}`) : null}
            />
            {errors[field] && <pre> <p className="help text-danger">{errors[field]}</p> </pre>}
        </div>
    )
}

export default NewDateGeneric